import { RiMusic2Line } from '@remixicon/react'

const trackWidths = [
	{ title: 'w-40', artist: 'w-24' },
	{ title: 'w-52', artist: 'w-20' },
	{ title: 'w-32', artist: 'w-28' },
	{ title: 'w-44', artist: 'w-16' },
	{ title: 'w-36', artist: 'w-24' },
]

export function PlaylistDetailSkeleton() {
	return (
		<div className="relative">
			{/* Atmospheric gradient — muted neutral during loading */}
			<div
				className="pointer-events-none absolute inset-x-0 top-0 h-72"
				style={{
					background:
						'radial-gradient(ellipse 80% 50% at 50% 0%, oklch(0.35 0 0 / 40%) 0%, transparent 100%)',
				}}
			/>

			<div className="relative mx-auto max-w-2xl px-6">
				{/* Hero skeleton */}
				<div className="flex items-center gap-5 pb-8 pt-12">
					<div className="skeleton-breathe flex size-20 shrink-0 items-center justify-center rounded-2xl bg-muted/60 shadow-lg">
						<RiMusic2Line className="size-8 text-muted-foreground/20" />
					</div>
					<div className="space-y-2.5">
						<div className="skeleton-shimmer h-8 w-48 rounded-sm" />
						<div className="skeleton-shimmer h-3 w-20 rounded-sm" style={{ animationDelay: '0.15s' }} />
					</div>
				</div>

				{/* Tracklist section header skeleton */}
				<div className="mb-3 flex items-center justify-between">
					<div className="skeleton-shimmer h-3 w-16 rounded-sm" style={{ animationDelay: '0.3s' }} />
					<div className="skeleton-shimmer h-3 w-12 rounded-sm" style={{ animationDelay: '0.35s' }} />
				</div>

				{/* Song rows — staggered shimmer */}
				<div className="divide-y divide-border/20">
					{trackWidths.map(({ title, artist }, i) => (
						<div
							key={i}
							className="flex items-center gap-3 px-2 py-2.5"
							style={{ animationDelay: `${0.08 * i}s` }}
						>
							{/* Track number */}
							<div className="flex size-6 shrink-0 items-center justify-center">
								<div
									className="skeleton-shimmer h-3 w-4 rounded-sm"
									style={{ animationDelay: `${0.4 + 0.1 * i}s` }}
								/>
							</div>

							{/* Song icon */}
							<div
								className="skeleton-shimmer size-9 shrink-0 rounded"
								style={{ animationDelay: `${0.45 + 0.1 * i}s` }}
							/>

							{/* Song info */}
							<div className="min-w-0 flex-1 space-y-1.5">
								<div
									className={`skeleton-shimmer h-3.5 rounded-sm ${title}`}
									style={{ animationDelay: `${0.5 + 0.1 * i}s` }}
								/>
								<div
									className={`skeleton-shimmer h-3 rounded-sm ${artist}`}
									style={{ animationDelay: `${0.55 + 0.1 * i}s` }}
								/>
							</div>
						</div>
					))}
				</div>

				{/* Details section skeleton */}
				<div className="mt-10 space-y-4">
					<div className="skeleton-shimmer h-3 w-14 rounded-sm" style={{ animationDelay: '1s' }} />
					<div className="space-y-3">
						<div className="skeleton-shimmer h-9 w-full rounded-sm" style={{ animationDelay: '1.05s' }} />
						<div className="flex gap-3">
							<div className="skeleton-shimmer h-9 w-20 rounded-sm" style={{ animationDelay: '1.1s' }} />
							<div className="skeleton-shimmer h-9 w-20 rounded-sm" style={{ animationDelay: '1.15s' }} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
